<template>
    <div class="text-center">
        <h6 v-if="title">{{title}}</h6>
        <h4 v-if="aboveTitle">{{aboveTitle}}</h4>
        <p v-if="descriptionTop" v-html="descriptionTop" />
        <div class="text-center my-3">
            <b-img fluid :src="image" v-if="image" class="transition-image"/>
        </div>
        <p v-if="description" v-html="description" />
        <div class="d-flex justify-content-end align-items-center py-4" v-if="buttonText">
            <loading-button :button-text="buttonText" @click="ctaClicked" :loading="loading"/>
        </div>
    </div>
</template>

<script>
import LoadingButton from "../../atoms/LoadingButton";
import {mapMutations} from "vuex";

export default {
    name: "TransitionCard",
    components: {LoadingButton},
    props:{
        aboveTitle: String,
        title: String,
        descriptionTop: String,
        description: String,
        step: Number,
        image: {
            type: String,
            required: true
        },
        buttonText: String,
        isAutoSkip: Boolean
    },
    data(){
        return{
            loading: false,
        }
    },
    methods:{
        ctaClicked(){
            this.loading = true;
            this.$emit('onClick');
        },
        ...mapMutations({
            setCurrentStep: 'profile/setWizardCurrentStep',
            setTotalSteps: 'profile/setWizardTotalSteps'
        })
    },
    mounted() {
        if (this.step) {
            this.setCurrentStep(this.step)
        }
        if (this.isAutoSkip) {
            setTimeout(()=>{
                this.$emit('onClick');
            }, 3000);
        }
        window.scrollTo(0,0);
    }
}
</script>

<style scoped>
    .transition-image{
        height: 240px;
    }
</style>
